export default {
  quotes: {},
  selectedquotes: {},
};
